import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
//import PropertyListed from './PropertyListed';
import ProductListed from './ProductListed';
import styled from 'styled-components';

const StyledRecommended = styled.div`
  width: calc(100% - 32px);
  max-width: 730px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(51, 51, 51, .15);
  border-radius: 10px;
  height: ${props => props.autoH ? "auto" : "60%"};
  overflow: hidden;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%);
  z-index: 8;
  padding: 0 0 20px 0;
  > div {
    text-align: left;
    padding: 0 20px;
    > span {
      letter-spacing: 1px;
    }

    &:first-child {
      h2 {
        font-family: 'Helvetica Neue LT W01_35 Thin';
        font-size: 1.25em;
        float: none;
        margin-bottom: 10px;
        @media (min-width: 640px) {
          font-size: 2em;
        }
      }
      > span:first-of-type {
        font-size: .825em;
        color: #999;
      }
      > span:last-of-type {
        font-size: 1em;
        display: block;
        width: 100%;
        color: #333;
        margin: 20px 0 0 0;
        text-transform: uppercase;
        letter-spacing: 0;
        @media (min-width: 640px) {
          margin: 40px 0 0 0;
        }
      }
      button {
        position: absolute;
        right: 20px;
        top: 40px;
        display: block;
        font-size: .825em;
        color: #000;
        text-transform: uppercase;
        span {
          line-height: 15px;
          letter-spacing: 1px;
          display: none;
          @media (min-width: 640px) {
            display: inline-block;
          }
        }
        i {
          margin: 2px 0 0 1em;
          width: 10px;
          height: 10px;
          float: right;
          svg {
            stroke: #000;
            stroke-width: 2;
          }
        }
      }
    }
    &:last-child {
      text-align: left;
      position: relative;
      padding-bottom: 40px;
      width: 100%;
      left: 0;
      height: calc(100% - 100px);
      overflow: auto;
      top: 0;
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-track {
        background-color: #EEE;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #21A0D2;
        border: 2px solid #EEE;
      }
      > ul {
        margin: 0;
        padding: 0 0 30px 0;
        li {
          width: 100%;
          margin: 8px 0;
          border-radius: 10px;
          background-color: #fff;
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, .05);
          height: 58px;
          padding: 16px;
          position: relative;
          > a {
            text-decoration: none;
            color: #333;
            display: block;
            font-size: .8125em;
            margin-left: 20px;
            position: absolute;
            left: 0;
            top: calc(50% + 1px);
            -webkit-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            transform: translateY(-50%);
            width: calc(100% - 30px);
            &:hover {
              color: #21A0D2;
            }
            small {
              text-transform: none;
              font-size: .875em;
            }
          }
        }
        @media (min-width: 1024px) {
        }
      }
    } /*> div*/
  }
`;

export default function Recommended (props) {

  const {bm, productData, toggleLayer, visible} = props;
  const data = {
    "cyclomethicone": ["Cetiol Ultimate", "Cetiol C 5", "Cetiol C 5C", "Cetiol Sensoft", "Cetiol OE", "Cetiol RLF", "Cetiol CC"],
    "dimethicone (100 cst)": ["Cegesoft PFO", "Cegesoft PS 6"],
    "light paraffin oil": ["Cetiol PGL"],
    "white paraffin oil": ["Myritol 331", "Myritol 312", "Myritol 318"]
  }
  const items = data[bm.toLowerCase()] || [];
  const products = items.map(item => productData.filter(prod => prod.title === item)[0]);
  const autoH = products.length < 5;

  return (
    <StyledRecommended autoH={autoH} >
      <div>
        <h2>Recommended Products</h2>
        <span>as a substitute for...</span>
        <span>{bm}</span>
        <Button icon="close" label="close" transparent onClick={toggleLayer}/>
      </div>
      <div>
        <ul>
          {products.map((item, index) =>
          <li key={index}>
            <a href={item.url} target="_blank" rel="noopener noreferrer">{item.name}</a>
          </li>
          )}
        </ul>
      </div>
    </StyledRecommended>)
}
